import {
	MobileInput,
	type MobileInputProps,
	type MobileInputValue,
} from '@ixigo/ui-kit/MobileInput';
import { useMemo } from 'react';
import type { CountryCodeMapping } from '@/api';

export interface MobileNumberWithISD {
	isdInfo: CountryCodeMapping;
	number: string;
}

export interface MobileNumberInputProps
	extends Omit<
		MobileInputProps,
		'onChange' | 'variant' | 'type' | 'value' | 'defaultValue'
	> {
	value: MobileNumberWithISD;
	onChange: (value: MobileNumberWithISD) => void;
}

export const MobileNumberInput = ({
	value: valueProp,
	onChange,
	label = 'Phone Number',
	...rest
}: MobileNumberInputProps) => {
	const value = useMemo(() => {
		return {
			country: valueProp.isdInfo,
			number: valueProp.number,
		};
	}, [valueProp]);

	const handleInputChange = (value: MobileInputValue) => {
		onChange({
			isdInfo: value.country,
			number: value.number,
		});
	};

	return (
		<MobileInput
			value={value}
			onChange={handleInputChange}
			label={label}
			{...rest}
		/>
	);
};
